import { render, staticRenderFns } from "./BonusLoader.vue?vue&type=template&id=46fd6464&"
import script from "./BonusLoader.vue?vue&type=script&lang=js&"
export * from "./BonusLoader.vue?vue&type=script&lang=js&"
import style0 from "./BonusLoader.vue?vue&type=style&index=0&id=46fd6464&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fd6464')) {
      api.createRecord('46fd6464', component.options)
    } else {
      api.reload('46fd6464', component.options)
    }
    module.hot.accept("./BonusLoader.vue?vue&type=template&id=46fd6464&", function () {
      api.rerender('46fd6464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/BonusLoader.vue"
export default component.exports